import http from '@plugin/axios'

export function changeSrmSupplierFormula(params: {id: string | number; formulaId: string | number}) {
  return http({
    url: '/srmSupplierFormula/changeSrmSupplierFormula',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: params
  })
}

export function cancelSrmSupplierFormula(params: {id: string | number}) {
  return http({
    url: '/srmSupplierFormula/cancelSrmSupplierFormula',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: params
  })
}

